import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    card: {
        minHeight: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column'
    },
    gridContButtons: {
        float: 'right',
        // marginTop: '50px',
        width: 'auto !important',
        [theme.breakpoints.down('sm')]: {
            marginTop: '60px'
        },
        '@media (max-width: 1294px) and (min-width: 960px) ': {
            marginTop: '50px'
        }
    },
    nameResp: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px'
        }
    },
    gridClass: {
        backgroundColor: 'white',
        border: '0px !important',
        margin: '10px 0px !important',
        height: '100%',
        width: '100%',
        fontSize: '13px !important'
    },
    visitsNumberContainer: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        paddingBottom: theme.spacing(1)
    },
    progressSection: {
        marginBottom: theme.spacing(1)
    },
    progressTitle: {
        marginBottom: theme.spacing(2)
    },
    progress: {
        marginBottom: theme.spacing(1),
        backgroundColor: 'rgb(236, 236, 236)'
    },
    pieChartLegendWrapper: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-end',
        marginRight: theme.spacing(1)
    },
    legendItemContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1)
    },
    fullHeightBody: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    tableWidget: {
        overflowX: 'auto'
    },
    progressBarPrimary: {
        backgroundColor: theme.palette.primary.main
    },
    progressBarWarning: {
        backgroundColor: theme.palette.warning.main
    },
    performanceLegendWrapper: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        marginBottom: theme.spacing(1)
    },
    legendElement: {
        display: 'flex',
        alignItems: 'center',
        marginRight: theme.spacing(2)
    },
    legendElementText: {
        marginLeft: theme.spacing(1)
    },
    serverOverviewElement: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: '100%'
    },
    serverOverviewElementText: {
        minWidth: 145,
        paddingRight: theme.spacing(2)
    },
    serverOverviewElementChartWrapper: {
        width: '100%'
    },
    mainChartBody: {
        overflowX: 'auto'
    },
    mainChartHeader: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        [theme.breakpoints.only('xs')]: {
            flexWrap: 'wrap'
        }
    },
    mainChartHeaderLabels: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.only('xs')]: {
            order: 3,
            width: '100%',
            justifyContent: 'center',
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(2)
        }
    },
    mainChartHeaderLabel: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: theme.spacing(3)
    },
    mainChartSelectRoot: {
        borderColor: `${theme.palette.text.hint}80 !important`
    },
    mainChartSelect: {
        padding: 10,
        paddingRight: 25
    },
    mainChartLegentElement: {
        fontSize: '16px !important',
        marginLeft: theme.spacing(1)
    },
    success: {
        backgroundColor: theme.palette.success.main,
        color: '#fff'
    },
    warning: {
        backgroundColor: theme.palette.warning.main,
        color: '#fff'
    },
    secondary: {
        backgroundColor: theme.palette.secondary.main,
        color: '#fff'
    },
    incidentContainer: {
        border: '1px solid #D5D5D5 !important',
        borderRadius: '12px',
        maxWidth: 'fit-content !important',
        backgroundColor: '#FFFFFF',
        fontSize: '14px !important',
        '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #E9EBF0 !important',
            borderRadius: '5px'
        },
        '& input:disabled': {
            WebkitTextFillColor: '#4E4E4E !important',
            color: '#4E4E4E !important',
            borderRadius: '5px',
            backgroundColor: '#eaeaea'
        },
        '& input': {
            fontWeight: 500
        },
        [theme.breakpoints.down('sm')]: {
            border: '0px !important'
        }
    },
    createButtons: {
        margin: 'auto',
        '& button': {
            margin: '20px'
        }
    },
    pageTitle: {
        color: '#272727',
        fontSize: '26px',
        fontWeight: 600,
        marginBottom: '10px',
        '& a': {
            float: 'right',
            color: '#8E8E8E'
        }
    },
    tableContainer: {
        width: '100%',
        height: '700px'
    },
    columnsContainer: {
        backgroundColor: 'white',
        border: '0px !important'
    },
    MuiList: {
        '& button.rdrStaticRange': {
            display: 'block'
        }
    },
    filterList: {
        float: 'right',
        position: 'relative',
        display: 'flex',
        '& fieldset': {
            borderRadius: '5px'
            // height: '50px',
        },
        '& #exportFilters fieldset': {
            borderColor: '#5CB9FD !important',
            height: '48px'
        },
        '& #exportFilters svg.MuiSelect-icon': {
            marginTop: '-4px !important'
        },
        '& #demo-simple-select3 svg': {
            display: 'none'
        },
        '& #demo-simple-select1': {
            '&>span': {
                fontSize: '13px',
                verticalAlign: 'super',
                marginLeft: '10px',
                color: '#fff'
            },
            '& svg': {
                marginRight: '-2px',
                verticalAlign: 'initial',
                fill: '#fff',
                width: '18px',
                height: '18px'
            }
        },
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap'
        }
    },
    formSet: {
        margin: '10px !important',
        width: '200px',
        '& .MuiSelect-select': {
            paddingTop: '22px !important',
            paddingBottom: '5px !important'
        },
        '& label.Mui-focused': {
            top: '17px !important'
        },
        [theme.breakpoints.down('sm')]: {
            width: 'auto'
        },
        [theme.breakpoints.down('xs')]: {
            width: '200px'
        },
        [theme.breakpoints.up('md')]: {
            float: 'right'
        }
    },
    selectFilters: {
        fontSize: '13px !important',
        '& div div': {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            height: '1.5em',
            whiteSpace: 'nowrap',
            paddingTop: '4px',
            paddingBottom: '3px'
        },
        [theme.breakpoints.down('sm')]: {
            width: '150px'
        },
        [theme.breakpoints.down('xs')]: {
            width: 'auto'
        }
    },
    selectFiltersDate: {
        fontSize: '13px !important',
        '& div div': {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            // width: '160px',
            height: '1.5em',
            width: '150px',
            whiteSpace: 'nowrap',
            paddingTop: '4px'
        },
        '& .MuiSvgIcon-root': {
            display: 'none !important'
        },
        [theme.breakpoints.down('sm')]: {
            width: '150px'
        },
        [theme.breakpoints.down('xs')]: {
            width: 'auto'
        }
    },
    selectIcon: {
        fill: '#FFF !important'
    },
    resizeIcon: {
        fill: '#FFF !important'
    },
    incidentListDiv: {
        width: '100%',
        '& h1': {
            position: 'absolute',
            top: '100px',
            zIndex: 10
        },
        '&>div': {
            marginTop: '0px !important'
        },
        '& .MuiDataGrid-sortIcon': {
            opacity: '0.6 !important'
        },
        '& .servcieCompCont': {
            paddingLeft: '0px'
        },
        '& .MuiDataGrid-row': {
            margin: '4px 0px 4px',
            border: '1px solid #eaeaea',
            borderRadius: '10px'
        },
        '& .MuiDataGrid-virtualScrollerContent': {
            height: 'auto !important',
            marginTop: '0px !important'
        },
        '& .MuiDataGrid-virtualScrollerRenderZone': {
            position: 'relative',
            '& .MuiDataGrid-row:first-child': {
                marginTop: '4px'
            }
        },
        '& .MuiDataGrid-overlay': {
            marginTop: '130px'
        },
        '& .MuiDataGrid-main .MuiDataGrid-columnsContainer': {
            overflow: 'hidden !important',
            border: '1px solid #E9EBF0 !important',
            borderRadius: '8px'
        },
        '& ul': {
            listStyleType: 'none'
        },
        '& .serviceList': {
            fontSize: '13px',
            color: '#E9EBF0',
            margin: '0px 5px',
            verticalAlign: 'middle'
        },
        [theme.breakpoints.down('xs')]: {
            '& h1': {
                top: '80px'
            }
        }
    },
    incidentForm: {
        margin: '10px !important',
        background: '#5BBCFE',
        border: '1px solid #5CB9FD',
        borderRadius: '5px',
        height: '53px',
        '& .MuiSelect-select': {
            padding: '14.5px 14px 16.5px 14px'
        },
        float: 'right',
        [theme.breakpoints.down('xs')]: {
            float: 'left'
        }
    },
    width150: {
        width: '150px !important'
    },
    width100: {
        width: '100px !important'
    },
    dnone: {
        display: 'none !important'
    },
    calenderSvg: {
        position: 'absolute',
        right: '8px',
        top: '15px',
        cursor: 'pointer'
        // [theme.breakpoints.down('sm')]: {
        //     right: '60px'
        // },
        // [theme.breakpoints.down('xs')]: {
        //     right: '8px'
        // }
    },
    noTransform: {
        textTransform: 'none !important'
    },
    fieldLabels: {
        fontSize: '13px !important'
    },
    incidentCreateForm: {
        '& .MuiTextField-root': {
            borderRadius: '5px',
            margin: '10px 0px 20px'
        },
        '& inputFields': {
            background: '#F2F2F2'
        }
    },
    inputFieldDescription: {
        fontSize: '12px !important'
    },
    inputSelect: {
        margin: '10px 0px 20px',
        fontSize: '13px !important'
    },
    serviceStatus: {
        flexDirection: 'row !important',
        display: 'flex !important',
        padding: '10px 0px 8px 15px !important',
        '& .MuiTextField-root, & .MuiSelect-root': {
            margin: '0px !important'
        },
        '&.MuiGrid-root:first-child': {
            margin: '0px 15px 0px 0px !important'
        }
    },
    changeTopPadding: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px !important'
        }
    },
    servicesInput: {
        '& div:second-child': {
            paddingLeft: '22px'
        }
    },
    // search
    tableWrapper: {
        position: 'relative'
    },
    tableContentWrapper: {
        display: 'flex',
        minHeight: '75vh',
        flexDirection: 'column'
    },
    container: {
        margin: '15px 10px'
    },
    cardTitle: {
        fontSize: '20px',
        display: 'inline-block',
        paddingTop: '5px'
    },
    newInstancesButton: {
        '&:hover, &:focus': {
            backgroundColor: `${theme.spacing(4)}px !important`,
            color: 'white !important'
        },
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        position: 'absolute',
        right: 0
    },
    containerCard: {
        padding: '20px 40px',
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '12px !important',
        marginBottom: '30px'
    },
    materailIcon: {
        display: 'flex',
        paddingLeft: `${theme.spacing(4)}px !important`,
        paddingRight: `${theme.spacing(4)}px !important`,
        color: theme.palette.text.secondary,
        fontSize: 24,
        overflowX: 'hidden'
    },
    materialIconText: {
        marginLeft: theme.spacing(1),
        fontSize: 13,
        display: 'inline-block'
    },
    nameIcon: {
        marginTop: '3px',
        width: '14px !important',
        height: '14px !important'
    },
    editIcon: {
        width: '14px !important',
        height: '14px !important'
    },
    editButton: {
        marginRight: '20px'
    },
    actionButtonContainer: {
        paddingTop: '0px !important',
        marginTop: '-7px !important'
    },
    popupTitle: {
        fontSize: '16px !important',
        textAlign: 'center',
        padding: '30px 60px !important'
    },
    alignRight: {
        textAlign: 'right'
    },
    popupButtonGrid: {
        display: 'block',
        margin: 'auto'
    },
    pb30: {
        paddingBottom: '30px'
    },
    mx10: {
        '&:hover, &:focus': {
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: 'white !important'
        },
        color: `${theme.palette.primary.main} !important`,
        borderColor: `${theme.palette.primary.main} !important`,
        marginLeft: '10px !important',
        marginRight: '10px !important',
        textTransform: 'revert !important'
    },
    newChip: {
        color: `${theme.palette.primary.dark} !important`,
        border: `1px solid ${theme.palette.primary.dark} !important`,
        backgroundColor: '#FFF !important',
        marginLeft: '5px',
        marginTop: '3px',
        fontSize: '10px !important',
        height: '18px !important'
    },
    tableSearchIcon: {
        width: '12px !important',
        height: '12px !important'
    },
    searchTextField: {
        marginTop: '12px !important'
    },
    resize: {
        fontSize: `${theme.palette.textSizeLarge} !important`
    },
    customPagination: {
        '& .MuiPagination-root .MuiPagination-ul': {
            flexWrap: 'nowrap'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child svg, & .MuiPagination-root .MuiPagination-ul li:last-child svg':
            {
                display: 'none'
            },
        '& .MuiPagination-root .MuiPagination-ul li:last-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child > button, & .MuiPagination-root .MuiPagination-ul li:last-child > button::before':
            {
                margin: '0px 5px'
            }
    },
    showPaginationDesc: {
        float: 'left',
        position: 'absolute',
        left: '0px'
    },
    pageItem: {
        border: '1px solid #E9EBF0 !important',
        margin: '0px !important',
        borderRadius: '0px !important',
        height: '32px !important',
        '& button::after': {
            margin: '0px'
        }
    },
    selectedAll: {
        backgroundColor: '#edf4fc !important',
        paddingTop: '0px !important',
        paddingBottom: '0px !important',
        '&:hover': {
            backgroundColor: '#1976d21f !important'
        }
    },
    selectedNone: {
        backgroundColor: '#fff !important',
        '&:hover': {
            backgroundColor: '#0000000a !important'
        }
    },
    reqdText: {
        float: 'right',
        [theme.breakpoints.down('xs')]: {
            float: 'left',
            margin: '10px'
        }
    },
    incidentActions: {
        '& > a, & > button': {
            minWidth: '15px',
            paddingRight: '0px'
        }
    }
}));
